import axios from "axios";
import Token from "../../utilities/jwt/Token";

export default class PacienteService extends Token {

    constructor() {
        super();
    }

    findByPaciente(request) {
        return axios({
            method: "PUT",
            url: this.api_url + "services-rest/api/generico/integracao",
            headers: {
                'Authorization': `Basic ${this.token().token}`,
                'Content-Type': 'application/json',
                'Integracao-Operacao': process.env.VUE_APP_INTEGRACAO_OPERACAO,
                'Integracao-Alias-Destino': process.env.VUE_APP_ALIAS,
                'Integracao-Async': 'false'
            },
            data: request
        }).then((res) => res.data);
    }

}
